import {navigateToFirstTeamInboxAction} from '../../../store/data/teammates/teammatesActions';
import {SetupGuideEnum} from '../../../store/stateless/onboardingSelectors';
import {
  OnboardingFlow,
  OnboardingFlowNameEnum,
  OnboardingFlowStepNameEnum,
  OnboardingFlowTransitionEnum,
} from './onboardingFlowTypes';

const isMobileDevice = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS|FxiOS/i.test(
    navigator.userAgent,
  ) ||
  (window.matchMedia && window.matchMedia('(max-width: 768px)').matches);

export const onboardingFlows: Record<OnboardingFlowNameEnum, OnboardingFlow> = {
  [OnboardingFlowNameEnum.ONBOARDING_QUESTIONNAIRE_FIRST_ADMIN]: {
    isApplicable: async (props) => {
      const {
        gating: {setupGuide, isUserFirstGlobalAdmin, isInManagedTrial},
      } = props;

      return setupGuide === SetupGuideEnum.ADMIN && isUserFirstGlobalAdmin && !isInManagedTrial;
    },
    shouldStart: async (props) => {
      const {
        gating: {wasOnboardingCompleted},
      } = props;

      return !wasOnboardingCompleted;
    },
    transitions: {
      [OnboardingFlowTransitionEnum.START_ONBOARDING]: async () => {
        if (isMobileDevice()) {
          return OnboardingFlowStepNameEnum.DESKTOP_RECOMMENDATION;
        }
        return OnboardingFlowStepNameEnum.ONBOARDING_QUESTIONNAIRE;
      },
      [OnboardingFlowTransitionEnum.DESKTOP_RECOMMENDATION_COMPLETE]: async () =>
        OnboardingFlowStepNameEnum.ONBOARDING_QUESTIONNAIRE,
      [OnboardingFlowTransitionEnum.ONBOARDING_QUESTIONNAIRE_COMPLETE]: async () =>
        OnboardingFlowStepNameEnum.ONBOARDING_QUESTIONNAIRE_ADMIN_WIZARD,
      [OnboardingFlowTransitionEnum.ONBOARDING_QUESTIONNAIRE_CANCEL]: async () =>
        OnboardingFlowStepNameEnum.ONBOARDING_QUESTIONNAIRE_ADMIN_WIZARD,
      [OnboardingFlowTransitionEnum.ADMIN_WIZARD_COMPLETE]: async () =>
        OnboardingFlowStepNameEnum.SANDBOX_DEMO,
      [OnboardingFlowTransitionEnum.ADMIN_WIZARD_CANCEL]: async () => OnboardingFlowStepNameEnum.SETUP_GUIDE,
      [OnboardingFlowTransitionEnum.SANDBOX_DEMO_COMPLETE]: async (props) => {
        const {dispatch} = props;
        dispatch(navigateToFirstTeamInboxAction());
        return OnboardingFlowStepNameEnum.SETUP_GUIDE;
      },
    },
  },
  // Default flow covers managed trials, and FLUs.
  // The managed trial and FLU cases will "split" once we add the guided demos to the flows framework.
  // See: guidedDemoSelectors
  [OnboardingFlowNameEnum.DEFAULT]: {
    isApplicable: async () => true,
    shouldStart: async (props) => {
      const {
        gating: {wasOnboardingCompleted},
      } = props;

      return !wasOnboardingCompleted;
    },
    transitions: {
      [OnboardingFlowTransitionEnum.START_ONBOARDING]: async () => {
        if (isMobileDevice()) {
          return OnboardingFlowStepNameEnum.DESKTOP_RECOMMENDATION;
        }
        return OnboardingFlowStepNameEnum.FLU_GUIDE;
      },
      [OnboardingFlowTransitionEnum.DESKTOP_RECOMMENDATION_COMPLETE]: async () =>
        OnboardingFlowStepNameEnum.FLU_GUIDE,
      [OnboardingFlowTransitionEnum.FLU_GUIDE_COMPLETE]: async () => undefined,
    },
  },
};

// All possible onboarding flows, highest precedence first.
export const flows = [
  OnboardingFlowNameEnum.ONBOARDING_QUESTIONNAIRE_FIRST_ADMIN,
  OnboardingFlowNameEnum.DEFAULT,
];
